import { Grid } from "@mui/material"


import './index'
import { useCallback} from "react";
import ThreeComponent from "../../../components/ThreeColumnsComponent";
import { EMPLOYEE_RECORDS_ONE, EMPLOYEE_RECORDS_TWO, EMPLOYEE_RECORDS_THREE } from "../../../constants/signalRequestConsts";
import TableRecords from "../documents/TableRecords";

const getDefaultDate = (months: number) => {
    const newDate = new Date();
    newDate.setMonth(newDate.getMonth() + months);
    return newDate;
}


const Records = () => {

    const ComponentOne = () => (
        <TableRecords
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            requestId={EMPLOYEE_RECORDS_ONE}
            status={2}
            hiddenFilterOptions={true}
        />
    );
    
    const ComponentTwo = useCallback(() => (
        <TableRecords
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            startDate={getDefaultDate(-6)}
            requestId={EMPLOYEE_RECORDS_TWO}
            status={1}
            hiddenFilterOptions={true}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);
    
    const ComponentThree = useCallback(() => (
        <TableRecords
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            endDate={getDefaultDate(-6)}
            requestId={EMPLOYEE_RECORDS_THREE}
            status={1}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);

    
    return (
        <Grid  container >

            <ThreeComponent
                useTabsNameAsTitle={true}
                tabsTitle={["No leídos", "Ultimos 6 meses", "Histórico"]}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
        </Grid>
    )

}

export default Records